import { useCallback, useEffect, useRef, useState } from 'react'
import { GripHorizontal } from 'lucide-react'

import { useAppStore } from '@core/store'
import { useJanelaAberta } from '@core/layout/useJanelaAberta'
import JuntarIfcPanel from '@modules/juntar-ifc/JuntarIfcPanel'

/** A janela flutuante que segura a ferramenta Juntar IFC.
 *
 *  Mesmo padrão das outras: arrasta-se pela barra de título e fica
 *  onde a pessoa a puser. O conteúdo vive em
 *  `@modules/juntar-ifc/JuntarIfcPanel`, que não sabe nada de janelas. */
export default function FloatingJuntarIfc() {
  const open = useAppStore((s) => s.juntarIfcOpen)
  const setOpen = useAppStore((s) => s.setJuntarIfcOpen)
  const { z, trazer } = useJanelaAberta('juntar-ifc', open)
  const [position, setPosition] = useState({ x: 460, y: 100 })
  const dragRef = useRef<{
    pointerStart: { x: number; y: number }
    posStart: { x: number; y: number }
  } | null>(null)

  const onTitleDown = useCallback(
    (e: React.PointerEvent<HTMLDivElement>) => {
      e.preventDefault()
      dragRef.current = {
        pointerStart: { x: e.clientX, y: e.clientY },
        posStart: { ...position },
      }
      try {
        ;(e.target as Element).setPointerCapture?.(e.pointerId)
      } catch {
        // Um alvo que já saiu do DOM atira aqui; arrastar continua a
        // funcionar pelos ouvintes da janela.
      }
    },
    [position],
  )

  useEffect(() => {
    const onMove = (e: PointerEvent) => {
      const d = dragRef.current
      if (!d) return
      setPosition({
        x: d.posStart.x + (e.clientX - d.pointerStart.x),
        y: d.posStart.y + (e.clientY - d.pointerStart.y),
      })
    }
    const onUp = () => {
      dragRef.current = null
    }
    window.addEventListener('pointermove', onMove)
    window.addEventListener('pointerup', onUp)
    return () => {
      window.removeEventListener('pointermove', onMove)
      window.removeEventListener('pointerup', onUp)
    }
  }, [])

  if (!open) return null

  return (
    <div
      onPointerDownCapture={trazer}
      className="fixed flex max-h-[80vh] w-[440px] max-w-[calc(100vw-16px)] flex-col rounded border border-[var(--color-border)] bg-[var(--color-surface)] shadow-2xl"
      style={{ zIndex: z, left: position.x, top: position.y }}
    >
      <div
        onPointerDown={onTitleDown}
        className="flex cursor-move items-center justify-center border-b border-[var(--color-border)] py-1 text-[var(--color-text-dim)]"
      >
        <GripHorizontal className="h-3 w-3" aria-hidden />
      </div>
      <JuntarIfcPanel aoFechar={() => setOpen(false)} />
    </div>
  )
}
